import { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router'

import { setDraggableContainerMountRef } from '@/store/sessionSlice'
import getCanvasSize from '@/utils/canvasSize'

import { CanvasAlignment } from '../components/canvas/constants'

export const useDualCanvasSize = (
  alignment: CanvasAlignment,
  extraHeight: number = 0,
) => {
  const location = useLocation()
  const dispatch = useDispatch()

  const containerRef = useRef<HTMLDivElement>(null)
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 })
  const [availableWidth, setAvailableWidth] = useState(0)
  const [availableHeight, setAvailableHeight] = useState(0)

  const updateSize = () => {
    if (!containerRef.current) return

    const { availableWidth, availableHeight } = getCanvasSize(
      location.pathname,
      extraHeight,
    )
    dispatch(setDraggableContainerMountRef(false))

    setDimensions({
      width:
        alignment === CanvasAlignment.VERTICAL
          ? availableWidth / 2
          : availableWidth,
      height:
        alignment === CanvasAlignment.HORIZONTAL
          ? availableHeight / 2
          : availableHeight,
    })

    setAvailableWidth(availableWidth)
    setAvailableHeight(availableHeight)
  }

  const setCanvasSize = (width: number, height: number) => {
    setDimensions({ width, height })
  }

  useEffect(() => {
    updateSize()
  }, [alignment, extraHeight])

  useEffect(() => {
    window.addEventListener('resize', updateSize)
    return () => window.removeEventListener('resize', updateSize)
  }, [])

  return {
    containerRef,
    dimensions,
    setCanvasSize,
    availableWidth,
    availableHeight,
  }
}
